import { render } from "./Buckets.vue?vue&type=template&id=63c86d02&scoped=true"
import script from "./Buckets.vue?vue&type=script&lang=js"
export * from "./Buckets.vue?vue&type=script&lang=js"

import "./Buckets.vue?vue&type=style&index=0&id=63c86d02&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c86d02"]])

export default __exports__